import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../../../../assets/common.scss';
export const templateProductsGrid = document.createElement('template');

templateProductsGrid.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
      <div class="content">
            <div class="grid">
                <gz-grid-view class="grid-view"></gz-grid-view>
            </div>
      </div>
  </div>
`;
